const config = {
  portalApiUrl: process.env.REACT_APP_API_BASE_URL || "",
  stripforcesUrl: process.env.REACT_APP_STRIPFORCES_URL || "",
  timeTrackerUrl: process.env.REACT_APP_TIME_TRACKER_URL || "",
  sap2000Url: process.env.REACT_APP_SAP2000_URL || "",
};

export default config;